<div class="container">
  <div class="container__editor">
    <ngs-code-editor
      style="height: 100%"
      [theme]="theme"
      [codeModel]="codeModel"
      [options]="options"
      (valueChanged)="onCodeChanged($event)"
    >
    </ngs-code-editor>
  </div>
  <div class="container__output">
    <div class="container__output__latex-container">
      <ng-katex [equation]="equation"></ng-katex>
    </div>
  </div>
</div>
<button
  (click)="downloadLatex()"
  class="downloadButton transition"
  title="Download LaTeX file"
>
  <img
    src="https://img.icons8.com/material-rounded/24/000000/download--v1.png"
  />
</button>
